module.exports = __webpack_public_path__ + "img/block-1-bg.0afa093f.png";